import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        VStepper,
        {
          attrs: { vertical: "" },
          model: {
            value: _vm.currentStep,
            callback: function ($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep",
          },
        },
        [
          _vm._l(_vm.steps, function (step, index) {
            return [
              _c(
                VStepperStep,
                {
                  attrs: { complete: step.complete, step: index + 1 },
                  on: {
                    click: function ($event) {
                      _vm.currentStep = index + 1
                    },
                  },
                },
                [
                  _vm._v(" " + _vm._s(step.name) + " "),
                  step.description
                    ? _c("small", [_vm._v(_vm._s(step.description))])
                    : _vm._e(),
                ]
              ),
              _c(
                VStepperContent,
                { key: index, attrs: { step: index + 1 } },
                [
                  _c(step.component, {
                    tag: "component",
                    attrs: {
                      worksheet: _vm.worksheet,
                      productInfo: _vm.productInfo,
                      worksheetTypeFields: _vm.worksheetTypeFields,
                    },
                    on: {
                      "update:worksheet": function ($event) {
                        _vm.worksheet = $event
                      },
                      updated: function ($event) {
                        return _vm.handleUpdated($event, index + 1)
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }